/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Abilities_Chip1_LabelInputs */



/**
* | output |
* | --- |
* | "Should I limit the abilities?" |
*
* @param {Uno_Edu_Agent_Abilities_Chip1_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_abilities_chip1_label = /** @type {((inputs?: Uno_Edu_Agent_Abilities_Chip1_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Abilities_Chip1_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Soll ich die Fähigkeiten beschränken?")
	return /** @type {LocalizedString} */ ("Should I limit the abilities?")
});